import styled from 'styled-components'

export default styled.div`
  padding: ${({ theme }) => theme.spacing.spacing12}px;
  border-radius: ${({ theme }) => theme.main.borderRadius}px;
  background-color: ${({ theme }) => theme.colors.light};
  box-shadow: ${({ theme }) => theme.main.shadowHover};

  span:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing8}px;
  }
`
